<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid }">
    <b-modal :id="modalId" title="Rút USDT" ok-title="Xác nhận" cancel-title="Đóng" size="md">
      <template #modal-header>
        <h4>Rút USDT</h4>
      </template>
      <template #default>
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <b-form @submit.prevent="handleSubmit(onSubmit)">
                <ValidationProvider name="amount" v-slot="{errors}">
                  <b-form-group label="Số lượng muốn rút">
                    <b-row>
                      <b-col>
                        <div class="input-group mb-2">
                          <input v-model="amount" type="number" :class="(errors.length > 0 ? ' is-invalid' : 'form-control')"/>
                          <div class="input-group-append">
                              <span class="input-group-text text-green" style="font-size: 14px;">
                                USDT
                              </span>
                          </div>
                          <div class="invalid-feedback">
                            <span>{{ errors[0] }}</span>
                          </div>
                        </div>
                        <p>Khả dụng:
                          <span :class="{
                          'text-green':userInfo.usdt_balance > 0,
                          'text-red':userInfo.usdt_balance <= 0
                        }">{{ userInfo.usdt_balance }} USDT</span>
                        </p>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider name="address" v-slot="{ errors }">
                  <b-form-group label="Địa chỉ ví">
                    <b-row>
                      <b-col>
                        <div class="input-group mb-2">
                          <input v-model="address" type="text" :class="(errors.length > 0 ? ' is-invalid form-control' : 'form-control')">
                          <div class="input-group-append">
                            <span class="input-group-text text-red" style="font-size: 14px;">
                              TRC20 Network
                            </span>
                          </div>
                          <div class="invalid-feedback">
                            <span>{{ errors[0] }}</span>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </ValidationProvider>
                <div v-show="userInfo.enabled_2fa === 0">
                  <hr>
                  <p>Vui lòng <b>kích hoạt 2FA</b> để thực hiện chức năng rút tiền</p>
                  <two-factor-authentication-modal/>
                </div>
                <div v-show="userInfo.enabled_2fa === 1">
                  <ValidationProvider name="otp" v-slot="{errors}">
                    <b-form-group label="Mã OTP (Phương thức 2FA)">
                      <b-row>
                        <b-col>
                          <div class="input-group mb-2">
                            <input v-model="otp" maxlength="6" type="text" :class="(errors.length > 0 ? ' is-invalid' : 'form-control')"/>
                            <div class="invalid-feedback">
                              <span>{{ errors[0] }}</span>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </ValidationProvider>
                </div>
              </b-form>
              <span class="text-danger">{{ serverError }}</span>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <b-button variant="primary" @click="handleSubmit(onSubmit)" :disabled="serverRequesting">Xác nhận</b-button>
        <b-button variant="default" @click="$bvModal.hide(modalId)">Đóng</b-button>
      </template>
    </b-modal>
  </ValidationObserver>
</template>
<script>
import { mapGetters } from 'vuex'
import api from '../../../store/api'
import TwoFactorAuthenticationModal from '@/components/application/account/TwoFactorAuthenticationModal'

export default {
  name: 'WithdrawModal',
  components: { TwoFactorAuthenticationModal },
  data () {
    return {
      address: '',
      amount: '',
      otp: ''
    }
  },
  props: {
    modalId: {
      type: String,
      default: 'withdraw-usdt-modal'
    },
    inputStyle: {
      type: Object,
      default: () => {
        return {
          width: '100%',
          display: 'block'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      'userInfo': 'Auth/userInfoState',
      'serverError': 'Setting/serverErrorsState',
      'serverRequesting': 'Setting/serverRequestingState'
    })
  },
  methods: {
    onSubmit ($event) {
      // call api
      api.transaction.withdraw_usdt({
        'address': this.address,
        'amount': this.amount,
        'otp': this.otp
      }).then((res) => {
        this.$swal({
          icon: 'success',
          title: 'Tạo đơn rút USDT thành công'
        })

        this.$bvModal.hide(this.modalId)
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })

        this.otp = ''
      })
    }
  }
}
</script>
